import FuseUtils from '@fuse/utils';
import FuseLoading from '@fuse/core/FuseLoading';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import settingsConfig from 'app/configs/settingsConfig';
import { useMemo } from 'react';
import SignInConfig from '../main/sign-in/SignInConfig';
import SignUpConfig from '../main/sign-up/SignUpConfig';
import SignOutConfig from '../main/sign-out/SignOutConfig';
import Error404Page from '../main/404/Error404Page';
import HomeConfig from '../main/main-pages/Home/HomeConfig';
import CommandAllConfig from '../main/main-pages/CommandAll/CommandAllConfig';
import CommandContractConfig from '../main/main-pages/CommandContract/CommandContractConfig';
import CommandOrderConfig from '../main/main-pages/CommandOrder/CommandOrderConfig';
import AppealsConfig from '../main/main-pages/Appeals/AppealsConfig';
import ClaimConfig from '../main/main-pages/Claim/ClaimConfig';
import LawSuitConfig from '../main/main-pages/LawSuit/LawSuitConfig';
import ProtestConfig from '../main/main-pages/Protest/ProtestConfig';
import AddOfferConfig from '../main/main-pages/AddOffer/AddOfferConfig';
import OffersConfig from '../main/main-pages/Offers/OffersConfig';
import StatisticsConfig from '../main/main-pages/statistics/StatisticsConfig';
import InstructionsConfig from '../main/main-pages/instruction/InstructionsConfig';
import InstrumentsConfig from '../main/main-pages/instruments/InstrumentsConfig';
import ChatComponentConfig from '../main/main-pages/chat-component/ChatComponentConfig';
import HeadOrganCommandsConfig from '../main/main-pages/head-organ-commands/HeadOrganCommandsConfig';
import TestConfig from '../main/main-pages/test/TestConfig';
import { localizeRoutes } from '../utils/route.utils';
import { LOCALE_CR, LOCALE_RU, LOCALE_UZ } from '../constants';

const routeConfigs = [
  TestConfig,
  SignOutConfig,
  SignInConfig,
  SignUpConfig,
  HomeConfig,
  CommandAllConfig,
  CommandContractConfig,
  CommandOrderConfig,
  AppealsConfig,
  ClaimConfig,
  LawSuitConfig,
  ProtestConfig,
  AddOfferConfig,
  OffersConfig,
  StatisticsConfig,
  InstructionsConfig,
  InstrumentsConfig,
  ChatComponentConfig,
  HeadOrganCommandsConfig,
];

const AuthHandle = () => {
  const navigate = useNavigate();

  function useQuery() {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
  }

  const query = useQuery();

  const code = query.get('code');
  if (code) {
    window.opener.authenticateCallback(code);
  }
};

const routes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs, settingsConfig.defaultAuth),
  ...localizeRoutes(routeConfigs, LOCALE_UZ),
  ...localizeRoutes(routeConfigs, LOCALE_CR),
  ...localizeRoutes(routeConfigs, LOCALE_RU),
  {
    path: '/',
    element: <Navigate to="/lawyer/home" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: 'loading',
    element: <FuseLoading />,
  },
  {
    path: '404',
    element: <Error404Page />,
  },
  {
    path: '/confirmation-required',
    element: <AuthHandle />, // element: <AuthConfirmation />,
  },
  {
    path: '*',
    element: <Navigate to="404" />,
  },
];

export default routes;
